export const REPORT_CARD_OPTIONS = {
  LOST: "LOST",
  BROKEN: "BROKEN",
  STOLEN: "STOLEN",
  CLIENT_INTERNAL_REASON: "CLIENT_INTERNAL_REASON",
} as const;

export type ReportCardOption =
  (typeof REPORT_CARD_OPTIONS)[keyof typeof REPORT_CARD_OPTIONS];

export interface ShipmentAddressModel {
  city: string;
  floor: string;
  region: string;
  country: string;
  zip_code: string;
  additional_info: string;
  apartment: string;
  neighborhood: string;
  phone: string;
  street_name: string;
  street_number: string;
}

export interface ShipmentUserModel {
  userId: number;
  streetName: string;
  streetNumber: number;
  city: string;
  zip: string;
  region: string;
  country: string;
  operationCountry: string;
  nationality: string;
  identificationType: string;
  taxIdentificationType: string;
  identificationValue: string;
  email: string;
  firstName: string;
  lastName: string;
  gender: string;
  birthday: string;
  deviceId: number;
}

export interface LatestShipmentAddressModel {
  address: ShipmentAddressModel;
  cardUser: ShipmentUserModel;
  receiverPhone: string;
  vendor: string;
  estimatedDeliveryDate: string;
  trackingNumber: string;
}
